
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Service from './pages/Service';
import Contact from './pages/Contact';
import ScrollToTop from './components/ScrollToTop';
import Terms from './pages/Terms';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TourPackages from './pages/TourPackages';
import Visas from './pages/Visas';
import Cruises from './pages/Cruises';
import HolidayBasket from './pages/HolidayBasket';
import { EuropamundoVacations } from './pages/EuropamundoVacations';
import VisaDetails from './pages/visaData';
import OurPartnerCruiseLines from './pages/OurPartnerCruiseLines';
import TopSellItineraries from './pages/TopSellItineraries';
import CruiseShips from './pages/CruiseShips';
import ShipDetails from './pages/ShipDetails';
import PackageDetail from './pages/PackageDetail';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import RouteChangeTracker from './RouteChangeTracker';
import ReactPixel from 'react-facebook-pixel';


const pixelId = '1066955475579455'; 
const options = {
  autoConfig: true, 
  debug: false,
};
ReactPixel.init(pixelId, null, options);

function App() {
  return (
    <>

      <Router>
      <RouteChangeTracker />
        <ToastContainer
          pauseOnHover
          theme="dark" />
        <ScrollToTop />
        
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/packages" element={<TourPackages />} />
            <Route path="/visas" element={<Visas />} />
            <Route path="/cruises" element={<Cruises />} />
            <Route path="/holiday-basket" element={<HolidayBasket />} />
            <Route path="/europamundo-vacations" element={<EuropamundoVacations />} />
            <Route path="/services" element={<Service />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/visa/:slug" element={<VisaDetails />} />
            <Route path="/our-partner-cruise-lines" element={<OurPartnerCruiseLines />} />
            <Route path="/top-sell-itineraries" element={<TopSellItineraries />} />
            <Route path="/cruise/:lineSlug" element={<CruiseShips />} />
            <Route path="/cruise-line/:lineSlug" element={<ShipDetails />} />
            <Route path="/package-details/:id" element={<PackageDetail />} />




          </Routes>
        </Layout>
      </Router>
    </>
  );
}

export default App;
